import { render, staticRenderFns } from "./CarerNavigationMobile.vue?vue&type=template&id=004c5b24"
import script from "./CarerNavigationMobile.vue?vue&type=script&lang=js"
export * from "./CarerNavigationMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports